import { gql } from "@apollo/client";

export const TOP_5_CLIP = gql`
  query Top5Clip {
    clipsNew(
      first: 1
      sort: LATEST
      filters: {
        clipProperties: [
          { key: "INTERNAL_FEATURED", value: "TOP_5", category: "TOP_5" }
        ]
      }
    ) {
      nodes {
        title
        thumbnailUrl(style: OVERLAY)
        url(orientation: LANDSCAPE)
        shareId
        views
        createdAt
        user {
          internalId
          avatarUrl
          username
        }

        associatedUsers {
          internalId
          username
          rank
          avatar
          userGroup {
            type
          }
        }
      }
    }
  }
`;
